@if ((applicationsList$ | async)?.length > 1) {
  <div class="switch-drawer-icon" matTooltip="Applications" (click)="onApplicationDrawer(applicationsCanvas)">
    <mat-icon class="fs-20 text-primary" [inline]="true"> arrow_back_ios_new </mat-icon>
  </div>
}

<ng-template #applicationsCanvas let-ApplicationOffcanvas>
  <div class="offcanvas-header">
    <h4 class="text-primary heading" id="offcanvas-basic-title">Applications</h4>
    <button type="button" class="btn-close d-none" aria-label="Close" id="application-drawer-close" (click)="ApplicationOffcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body switch-drawer-container px-4 d-flex flex-column gap-4">
    @for (item of applicationsList$ | async; track $index) {
      <div
        #applicationCard
        class="application-card p-2 d-flex flex-column gap-2 border-radius-10 w-100 border-one border-light-2-gray"
        [ngClass]="{ active: +item.AID === +(currentApplication$ | async)?.AID }"
        [matTooltip]="item?.ApplicationTitle"
        (click)="onOpenURL(item, applicationCard)">
        <div class="application-card__image">
          @if (item?.ApplicationSymbolType === "SVG_LOGO") {
            <div class="d-flex justify-content-center align-items-center" [innerHTML]="item?.ApplicationSymbolUrl | sanitizer: 'html'"></div>
          } @else {
            <img [src]="item?.ApplicationSymbolUrl" [alt]="item.ApplicationSymbolName" />
          }
        </div>
        <div class="application-card__title">{{ item?.ApplicationTitle }}</div>
        @if (+item.AID === +(currentApplication$ | async)?.AID) {
          <mat-icon class="application-card__checked">check_circle</mat-icon>
        }
      </div>
    }
  </div>
</ng-template>
